// extracted by mini-css-extract-plugin
export default {"container":"style_container__JibZ1","content":"style_content__ErW-e","shadow":"style_shadow__fBIv9"};